import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Top Section */}
        <div className="py-14 md:py-20">
          <div className="mb-16">
            <span className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
              OOPBUY
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
            {/* Left - About */}
            <div>
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-6">
                OOPBUY Spreadsheet ist deine vertrauenswürdige Quelle für smartes internationales Shopping. Wir helfen dir, die besten Deals zu finden und intelligent einzukaufen.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/20 hover:border-background-50/40 hover:bg-background-50/10 transition-colors cursor-pointer"
                  aria-label="OOPBUY Spreadsheet"
                >
                  <i className="ri-global-line text-background-50/70"></i>
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/20 hover:border-background-50/40 hover:bg-background-50/10 transition-colors cursor-pointer"
                  aria-label="Kaspreadsheet"
                >
                  <i className="ri-shopping-bag-line text-background-50/70"></i>
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/20 hover:border-background-50/40 hover:bg-background-50/10 transition-colors cursor-pointer"
                  aria-label="Shop"
                >
                  <i className="ri-store-line text-background-50/70"></i>
                </a>
              </div>
            </div>

            {/* Middle - Links */}
            <div className="flex flex-col gap-4">
              <p className="text-xs font-semibold text-background-50/40 uppercase tracking-widest mb-2">Links</p>
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                Startseite
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                OOPBUY Spreadsheet Guide
              </Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                Kaspreadsheet Shop
              </a>
            </div>

            {/* Right - Legal */}
            <div className="flex flex-col gap-4">
              <p className="text-xs font-semibold text-background-50/40 uppercase tracking-widest mb-2">Rechtliches</p>
              <span className="text-sm text-background-50/60 whitespace-nowrap">{t('footer.impressum')}</span>
              <span className="text-sm text-background-50/60 whitespace-nowrap">{t('footer.privacy')}</span>
              <span className="text-sm text-background-50/60 whitespace-nowrap">{t('footer.disclaimer')}</span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-background-50/10"></div>

        {/* Bottom */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            {t('footer.copyright')}
          </p>
          <nav className="flex items-center gap-6">
            <span className="text-xs text-background-50/40 cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">{t('footer.impressum')}</span>
            <span className="text-xs text-background-50/40 cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">{t('footer.privacy')}</span>
            <span className="text-xs text-background-50/40 cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">{t('footer.contact')}</span>
          </nav>
        </div>
      </div>
    </footer>
  );
}